import React from 'react';

import Tooltip from '../../../../../../library/tooltip/tooltip';
import {
  BookmarkSolidIcon,
  CircleSolidIcon,
  StarSolidIcon
} from '../../../../../../shared/icons/icons';
import TreadwellIcon from '../treadwell-icon/treadwell-icon';

import { PRODUCT_TILE_TYPES } from '../../../../../../shared/constants/treadwell';

import './top-three-tile-header.scss';

interface TopThreeTileHeaderProps {
  infoMessage?: string;
  isTreadwell?: boolean;
  rank?: number;
  type: typeof PRODUCT_TILE_TYPES[keyof typeof PRODUCT_TILE_TYPES];
}

function TopThreeTileHeader(props: TopThreeTileHeaderProps) {
  const { infoMessage, isTreadwell, rank, type } = props;

  let styleName;
  let text;
  let Icon;

  if (isTreadwell && rank) {
    if (rank > 1) {
      styleName = 'our-treadwell-recommendation';
      text = 'Top Recommendation';
    } else if (rank === 1) {
      styleName = 'our-treadwell-recommendation-top';
      text = 'Top Recommendation';
    }
  } else if (!rank && type === PRODUCT_TILE_TYPES.RECOMMENDED) {
    styleName = 'our-recommendation';
    text = 'Our Recommendation';
    Icon = BookmarkSolidIcon;
  } else if (type === PRODUCT_TILE_TYPES.ORIGINAL_EQUIPMENT) {
    styleName = 'original-equipment';
    text = 'Original Equipment';
  } else if (type === PRODUCT_TILE_TYPES.BEST_SELLER) {
    styleName = 'best-seller';
    text = 'Best Seller';
    Icon = CircleSolidIcon;
  } else if (type === PRODUCT_TILE_TYPES.HIGHEST_RATED) {
    styleName = 'highest-rated';
    text = 'Highest Rated';
    Icon = StarSolidIcon;
  }

  return (
    <div styleName={styleName}>
      <div styleName="header">
        <span styleName="header-icon">
          {Boolean(Icon) && <Icon />}
          {isTreadwell && <TreadwellIcon rank={rank} />}
          {type === PRODUCT_TILE_TYPES.ORIGINAL_EQUIPMENT && 'O.E.'}
        </span>
        <span styleName="header-text">{text}</span>
      </div>
      <Tooltip ariaLabel="info" content={infoMessage} styleName="info" />
    </div>
  );
}

export default TopThreeTileHeader;
